import * as React from 'react';
import './styles.scss';
import { forwardRef, HTMLProps } from 'react';

export type ButtonProps = (React.ButtonHTMLAttributes<HTMLButtonElement> | HTMLProps<HTMLAnchorElement>) & {
  buttonType?: 'button' | 'link' | undefined;
}

export const Button = forwardRef<HTMLButtonElement | HTMLAnchorElement, ButtonProps>(
  (props, buttonRef) => {
    const htmlProps = { ...props };
    delete htmlProps["buttonType"];
    if (props.buttonType !== 'link') {
      return (
        <button
          {...(htmlProps as React.ButtonHTMLAttributes<HTMLButtonElement>)}
          className={`cmp-button ${props.className || 'cmp-button--primary'}`}
          ref={buttonRef as React.Ref<HTMLButtonElement>}
        >
          {props.children}
        </button>
      )
    }
    else {
      return (<a {...(htmlProps as HTMLProps<HTMLAnchorElement>)} className={`cmp-button ${props.className || 'cmp-button--primary'}`} ref={buttonRef as React.Ref<HTMLAnchorElement>} >{props.children}</a>)
    }
  }
);
